module.exports = __webpack_public_path__ + "static/media/credit-card.9f4f6fe7.svg";